import themeGet from "@styled-system/theme-get";
import styled from 'styled-components';

import ButtonOrLink from '../ButtonOrLink';

export const Heading = styled.h2<{ leftAlign?: string }>`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.heading2.fontWeight')};
  font-size: ${themeGet('typography.mobile.heading2.fontSize')};
  line-height: ${themeGet('typography.mobile.heading2.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.heading2.letterSpacing')};
  color: ${themeGet('colors.black')};
  text-align: ${(props) => (props.leftAlign ? 'left' : 'center')};
  margin: 0px 20px 20px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 0px 0 40px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: ${themeGet('typography.desktop.heading2.fontSize')};
    line-height: ${themeGet('typography.desktop.heading2.lineHeight')};
  }
`;

export const FAQsLink = styled(ButtonOrLink)`
  text-align: center;
  text-decoration: underline;
  font-weight: 600;
  display: inline-block;
  margin: 40px auto 0;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 30px auto 0;
  }
`;
